import Header from "./viewport/header";
import Footer from "./viewport/footer";
import Main from "./viewport/main";

function App() {
  return (
    <div className="wrapper">
      <Header />

      <Main />

      <Footer />
    </div>
  );
}

export default App;
